import { ContentApi, Method } from './ContentApi';
import { Post, Posts } from './Post';
import { Category } from './Category';
import { log } from '../lib/Logger';

export class RestContentApi implements ContentApi {
  constructor(protected readonly endpoint: string) {}

  async getPost(category: Category, slug: string): Promise<Post | null> {
    const url = `${this.endpoint}/posts/${category}/${slug}`;
    const post = (await this.request(url, 'GET')).json as null | Post;
    if (post === null) {
      return null;
    }
    return post;
  }

  async getPosts(category: Category): Promise<Posts> {
    const url = `${this.endpoint}/posts/${category}`;
    const posts = (await this.request(url, 'GET')).json as Posts;
    return posts;
  }

  protected async request(
    url: string,
    method: Method,
    init: RequestInit = {}
  ): Promise<{ status: number; json: Object }> {
    const requestInit = Object.assign(
      {
        method: method,
        cache: 'no-cache',
        // Send credential to any host (for testing localhost).
        credentials: 'include',
        mode: 'cors',
      },
      init
    );

    const response = await fetch(url, requestInit);
    try {
      return { status: response.status, json: await response.clone().json() };
    } catch (e) {
      const text = await response.text();
      const error = `Could not parse JSON: ${text}`;
      log('error', error);
      throw new Error(error);
    }
  }
}
